import { render, staticRenderFns } from "./Ellipsis.vue?vue&type=template&id=8206ba6e&scoped=true&"
import script from "./Ellipsis.vue?vue&type=script&lang=js&"
export * from "./Ellipsis.vue?vue&type=script&lang=js&"
import style0 from "./Ellipsis.vue?vue&type=style&index=0&id=8206ba6e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8206ba6e",
  null
  
)

component.options.__file = "Ellipsis.vue"
export default component.exports